import { Badge } from '@/components/common/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/common/table'
import { TabsContent, TabsTrigger } from '@/components/common/tabs'
import type { TransactionsContext } from '@/queries/transactionsContext.query'
import type { Vault } from '@/types/vault'
import { fromUnixTimestamp } from '@vaultsfyi/common/utils'
import { formatDate, formatTokenValue } from '@vaultsfyi/common/utils'
import { useMemo } from 'react'
import { z } from 'zod'

export const BORING_REDEEM_TAB_NAME = 'boringRedeem'

export const BoringWaitForRedeemTabTrigger = ({ className }: { className?: string }) => {
  return (
    <TabsTrigger value={BORING_REDEEM_TAB_NAME} className={className}>
      Pending
    </TabsTrigger>
  )
}

const redeemStateSchema = z
  .object({
    deadline: z.coerce.number(),
    assetAmount: z.string(),
    lpTokenAmount: z.string(),
  })
  .optional()

export function BoringWaitForRedeemTab({
  vault,
  transactionsContext,
}: {
  vault: Vault
  transactionsContext: TransactionsContext
}) {
  const claimData = useMemo(() => {
    return redeemStateSchema.parse((transactionsContext?.vaultSpecificData as Record<string, any>)?.redeemState)
  }, [transactionsContext])

  return (
    <TabsContent value={BORING_REDEEM_TAB_NAME} className="mt-3 flex flex-col gap-3 md:mt-4 md:gap-4">
      {claimData && (
        <Table>
          <TableHeader>
            <TableRow variant="header">
              <TableHead>Amount</TableHead>
              <TableHead>Deadline</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                {formatTokenValue(
                  { value: claimData.assetAmount, decimals: vault.asset.decimals },
                  { minimumFractionDigits: 2 }
                )}{' '}
                {vault.asset.symbol}
              </TableCell>
              <TableCell>
                {formatDate({
                  timestamp: fromUnixTimestamp(Number(claimData.deadline)),
                  showYear: true,
                  showTime: true,
                })}
              </TableCell>
              <TableCell>
                <Badge color={'orange'}>Pending</Badge>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      <div className="flex flex-col gap-2 text-center">
        <p className="bold font-bold text-heading-foreground text-m">Withdrawal in progress...</p>
        <div className="text-gray-500 text-sm">
          Withdrawals may take for up to 3 days to process. Do not move your LP tokens until the process is complete or
          the withdrawal will fail.
        </div>
      </div>
    </TabsContent>
  )
}
